import { useEffect } from 'react';
import { trackWeatherPageView } from '@alltrails/core/utils/weatherDotComPixel';

const DEFER_ANALYTICS_MS = 2000;

const useWeatherPixel = () => {
  useEffect(() => {
    if (typeof requestIdleCallback !== 'undefined') {
      const id = requestIdleCallback(() => trackWeatherPageView(), { timeout: DEFER_ANALYTICS_MS });
      return () => cancelIdleCallback(id);
    } else {
      const id = setTimeout(() => trackWeatherPageView(), DEFER_ANALYTICS_MS);
      return () => clearTimeout(id);
    }
  }, []);
};

export default useWeatherPixel;
